import { render, staticRenderFns } from "./student_type.vue?vue&type=template&id=cacbf370"
import script from "./student_type.vue?vue&type=script&lang=js"
export * from "./student_type.vue?vue&type=script&lang=js"
import style0 from "./student_type.vue?vue&type=style&index=0&id=cacbf370&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports